<template>
    <div class="content search_content">
        <v-row class="search_box">
            <v-col>
              <topNav></topNav>
            </v-col>
        </v-row>
        <div class="manager_content_wrapper">
            <div class="tit_name marb24Imp">专利管家</div>
            <div class="bread_route marb10">
                <div class="flex_style left">
                    <span class="text hand" @click="goBack">专利管家</span>
                    <v-icon>mdi-chevron-right</v-icon>
                    <span class="active">对象设置</span>
                </div>
            </div>
            <div class="table_content_wrapper">
                <div class="flex_style betw marb10">
                    <div class="tit_name">管理对象</div>
                    <div class="icon_name" @click="addObjectEvent">
                        <v-icon>mdi-plus</v-icon>
                        <div class="text">添加管理对象</div>
                    </div>
                </div>
                <div class="table_wrapper">
                    <v-data-table
                        :headers="headers"
                        :items="managerList"
                        disable-pagination
                        :calculate-widths="true"
                        hide-default-footer
                        no-data-text="暂无数据"
                        class="common_table"
                    >
                     <template v-slot:[`item.actions`]="{ item }">
                            <div class="flex_style left">
                                <!-- <div class="btn_item" @click="editObjectEvent(item)"><i class="icon edit"></i></div> -->
                                <div class="btn_item" @click="delObject(item)"><i class="icon del"></i></div>
                            </div>
                        </template>
                    </v-data-table>
                </div>
                <div class="flex_style betw marb10 mart32" v-if="false">
                    <div class="tit_name">消息通知人</div>
                    <div class="icon_name" @click="addPersonEvent">
                        <v-icon>mdi-plus</v-icon>
                        <div class="text">添加通知人</div>
                    </div>
                </div>
                <div class="table_wrapper" v-if="false">
                    <v-data-table
                        :headers="headers1"
                        :items="peopleList"
                        :calculate-widths="true"
                        disable-pagination
                        hide-default-footer
                        no-data-text="暂无数据"
                        class="common_table"
                    >
                    <template v-slot:[`item.notice`]="{ item }">
                            <div class="switch_item">
                                <v-switch
                                v-model="item.open"
                                inset
                                label=""
                                @change="switchChange(item.id, item.open)"
                                ></v-switch>
                            </div>
                        </template>
                              <template v-slot:[`item.actions`]="{ item }">
                            <div class="overflow2">
                                <div class="flex_style left">
                                    <div class="btn_item" @click="editPersonEvent(item)"><i class="icon edit"></i></div>
                                    <div class="btn_item" @click="delPerson(item)"><i class="icon del"></i></div>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </div>
        <v-dialog
            v-model="objectDialog"
            width="500"
            >
            <v-card>
                <v-card-title><span class="fontbold font18">{{objectTit}}</span> <v-icon @click="handleObjCancel">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="addSpace_wrapper addManager_wrappper">
                        <div class="common_input_style" v-if="objectTit == '修改管理对象'">
                            <v-text-field
                                hide-details="auto"
                                outlined
                                placeholder="请输入管理的企业名称"
                                v-model="form.companyName"
                            ></v-text-field>
                        </div>
                        <div class="common_input_style" v-if="objectTit == '添加管理对象'">
                            <v-combobox
                                v-model="compName"
                                :items="compNameItems"
                                label="企业名称"
                                append-icon=""
                                placeholder="请输入管理的企业名称"
                                :search-input.sync="search"
                                clearable
                                light
                                outlined
                                hide-details
                                hide-selected
                            >
                            </v-combobox>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handleObjCancel">取消</v-btn>
                    <v-btn v-if="objectTit == '添加管理对象'" color="primary" @click="handleObjAddOk">提交</v-btn>
                    <v-btn v-if="objectTit == '修改管理对象'" color="primary" @click="handleObjEditOk">提交</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
         <v-dialog
            v-model="personDialog"
            width="500"
            >
            <v-card>
                <v-card-title><span class="fontbold font18">{{personTit}}</span> <v-icon @click="handlePersonCancel">mdi-close</v-icon></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="addSpace_wrapper addManager_wrappper">
                        <div class="common_input_style marb30">
                            <v-text-field
                                hide-details="auto"
                                outlined
                                placeholder="请输入通知人姓名"
                                label="姓名"
                                v-model="form.name"
                            ></v-text-field>
                        </div>
                        <div class="common_input_style marb30">
                            <v-text-field
                                hide-details="auto"
                                outlined
                                placeholder="请输入通知人手机号"
                                v-model="form.webChat"
                                label="手机号"
                            ></v-text-field>
                        </div>
                        <div class="common_input_style">
                            <v-text-field
                                hide-details="auto"
                                outlined
                                placeholder="请输入通知人邮箱"
                                v-model="form.email"
                                label="邮箱"
                            ></v-text-field>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handlePersonCancel">取消</v-btn>
                    <v-btn v-if="personTit == '添加信息'" color="primary" @click="handlePersonAddOk">提交</v-btn>
                    <v-btn v-if="personTit == '编辑信息'" color="primary" @click="handlePersonEditOk">提交</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapActions, mapState} from 'vuex';
import topNav from "@/components/widgets/topNav.vue";
export default {
    data() {
        return {
            objectDialog: false,
            personDialog: false,
            objectTit: '修改管理对象',
            personTit: '编辑信息',
            managerList: [
                {
                    name: '邳州华创锂电池研究院有限公司'
                }
            ],
            headers: [
                {
                    text: '管理对象名称',
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: '操作',
                    align: 'start',
                    width: '100px',
                    sortable: false,
                    value: 'actions'
                }
            ],
            headers1: [
                {
                    text: '姓名',
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: '手机号',
                    align: 'start',
                    sortable: false,
                    value: 'webChat'
                },
                {
                    text: '邮箱',
                    align: 'start',
                    sortable: false,
                    value: 'email'
                },
                {
                    text: '开启消息通知',
                    align: 'start',
                    sortable: false,
                    value: 'notice'
                },
                {
                    text: '操作',
                    align: 'start',
                    width: '100px',
                    sortable: false,
                    value: 'actions'
                }
            ],
            peopleList: [
            ],
            compName: '',
            compNameItems: [],
            search: '',
            form: {},
        }
    },
    mounted() {
        this.getObjectData()
        this.getPersonList()
    },
    watch: {
         search(val) {
            this.getSuggest(val);
        },
    },
    components: {topNav},
    methods: {
        ...mapActions("search", ["querySug"]),
        ...mapActions('manager',['getOpObject','addOpObject','delOpObject',
        'getNotifyPerList','addNotifyPerson','updateNotifyPerson','delNotifyPerson','closeNotifyPerson']),
        goBack() {
            this.$router.push({
                path: '/manager'
            })
        },
        getObjectData() {
            let data = {}
            let _this = this
            this.getOpObject({data: data,handle(res) {
                if(res.success) {
                    _this.managerList = res.model.pagination.data
                }
            }})
        },
        editObjectEvent(val) {
            this.objectDialog = true
            this.objectTit = '修改管理对象'
        },
        addObjectEvent() {
            this.objectDialog = true
            this.objectTit = '添加管理对象'
        },
        getSuggest(val) {
            this.compName = val
            let _this = this;
            let data = {
                params: {
                    q: val,
                },
            };
            this.querySug({data: data,handle(res) {
                    let data = res.data;
                    let newData = [];
                    if (data && data.length > 0) {
                        data.forEach((item) => {
                            newData.push(item.text);
                        });
                    }
                    _this.compNameItems = newData;
                }
            });
        },
        handleObjAddOk() {
            let data = {
                params: {
                    name: this.compName
                }
            }
            let _this = this
            this.addOpObject({data: data,handle(res) {
                _this.objectDialog = false
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    })
                    _this.getObjectData()
                }else {
                     _this.$message({
                        type: 'info',
                        message: res.message
                    })
                }
            }})
        },
        handleObjEditOk() {

        },
        handleObjCancel() {
            this.objectDialog = false
        },
        delObject(val) {
            this.$msgbox.confirm('此操作将永久删除该管理对象, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    params: {
                        id: val.id
                    }
                }
                let _this = this
                this.delOpObject({data: data,handle(res) {
                    if(res.success) {
                        _this.$message({
                            type: 'success',
                            message: res.message
                        })
                        _this.getObjectData()
                    }else {
                        _this.$message({
                            type: 'info',
                            message: res.message
                        })
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        getPersonList() {
            let data = {}
            let _this = this
            this.getNotifyPerList({data: data,handle(res){
                if(res.code =='0') {
                    let list = res.targetList
                    list.map((item)=>{
                        item.open = !item.closed
                    })
                    console.log('list', list)
                    _this.peopleList = list
                }else {
                    _this.$message({
                        type: 'info',
                        message: res.message
                    });       
                }
            }})
        },
        addPersonEvent() {
            this.personDialog = true
            this.form = {}
            this.personTit = '添加信息'
        },
        editPersonEvent(val) {
            this.form = JSON.parse(JSON.stringify(val))
            this.personDialog = true
            this.personTit = '编辑信息'
        },
        handlePersonAddOk() {
            if(!this.form.name) {
                this.$message({
                    type: 'info',
                    message: '请输入通知人信息'
                })
                return false
            }
            if(!this.form.email) {
                this.$message({
                    type: 'info',
                    message: '请输入通知人邮箱'
                })
                return false
            }else {
                let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
                if(!reg.test(this.form.email)){
                    this.$message({
                        type: 'info',
                        message: '请输入正确的邮箱地址'
                    })
                    return false
                }
            }
            if(this.form.webChat) {
                let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if(!reg.test(this.form.webChat)){
                    this.$message({
                        type: 'info',
                        message: '请输入正确的手机号'
                    })
                    return false
                }
            }
            // this.personDialog = false
            let data = {
                params: this.form
            }
            let _this = this
            this.addNotifyPerson({data: data,handle(res) {
                _this.personDialog = false
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    }); 
                    _this.getPersonList()
                }else {
                    _this.$message({
                        type: 'info',
                        message: res.message
                    }); 
                }
            }})
        },
        handlePersonEditOk() {
            if(!this.form.name) {
                this.$message({
                    type: 'info',
                    message: '请输入通知人信息'
                })
                return false
            }
            if(!this.form.email) {
                this.$message({
                    type: 'info',
                    message: '请输入通知人邮箱'
                })
                return false
            }else {
                let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
                if(!reg.test(this.form.email)){
                    this.$message({
                        type: 'info',
                        message: '请输入正确的邮箱地址'
                    })
                    return false
                }
            }
            if(this.form.webChat) {
                let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if(!reg.test(this.form.webChat)){
                    this.$message({
                        type: 'info',
                        message: '请输入正确的手机号'
                    })
                    return false
                }
            }
            let form1 = {
                id: this.form.id,
                name: this.form.name,
                email: this.form.email,
                WebChat: this.form.webChat
            }
            let data = {
                params: form1
            }
            let _this = this
            this.updateNotifyPerson({data: data,handle(res) {
                _this.personDialog = false
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    }); 
                    _this.getPersonList()
                }else {
                    _this.$message({
                        type: 'info',
                        message: res.message
                    }); 
                }
            }})
        },
        handlePersonCancel() {
            this.personDialog = false
        },
        delPerson(val) {
            this.$msgbox.confirm('此操作将永久删除该通知人, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //接口
                let data = {
                    params: {
                        id: val.id
                    }
                }
                let _this = this
                this.delNotifyPerson({data: data,handle(res) {
                    if(res.success) {
                        _this.$message({
                            type: 'success',
                            message: res.message
                        });
                        _this.getPersonList()
                    }else {
                        _this.$message({
                            type: 'info',
                            message: res.message
                        }); 
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        switchChange(id,val) {
            let val1 = !val
            let tit = '关闭'
            if(val) {
                tit = '开启'
            }
             this.$msgbox.confirm('此操作将'+tit+'通知, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               let data = {
                    params: {
                        id: id,
                        closed: val1
                    }
                }
                let _this = this
                this.closeNotifyPerson({data:data,handle(res) {
                    if(res.success) {
                        _this.$message({
                            type: 'success',
                            message: res.message
                        }); 
                        _this.getPersonList()
                    }else {
                        _this.$message({
                            type: 'info',
                            message: res.message
                        }); 
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消设置'
                }); 
                this.getPersonList()         
            });
            
        }
    }
}
</script>